import { z } from 'zod';

import {
  getStudentFeedbacksSortOrderSchema,
  StudentFeedbackIssueLabelMap,
  studentFeedbackIssueSchema,
  StudentFeedbackStatusLabelMap,
  studentFeedbackStatusSchema,
} from '@airreading/common/data';
import { paginationRequestSchema } from '@/lib/pagination';

export const allStudentFeedbackIssues = studentFeedbackIssueSchema.options;
export const allStudentFeedbackStatuses = studentFeedbackStatusSchema.options;

export const getStudentFeedbackIssueOptions = () =>
  allStudentFeedbackIssues.map((issue) => ({
    label: StudentFeedbackIssueLabelMap[issue],
    value: issue,
  }));

export const getStudentFeedbackStatusOptions = () =>
  allStudentFeedbackStatuses.map((status) => ({
    label: StudentFeedbackStatusLabelMap[status],
    value: status,
  }));

export const studentFeedbacksSearchSchema = paginationRequestSchema.extend({
  query: z.string().optional(),
  studentId: z.string().optional(),
  studentFeedbackIssues: z.array(studentFeedbackIssueSchema).optional(),
  statuses: z.array(studentFeedbackStatusSchema).optional(),
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  sortBy: getStudentFeedbacksSortOrderSchema.optional(),
});
export type StudentFeedbacksTableRouteConstraint = z.infer<typeof studentFeedbacksSearchSchema>;
